{
  "version": "1.2.6",
  "objects": {
    "7493635533102491110": {
      "type": "frame",
      "id": "7493635533102491110",
      "z": 1596,
      "textContent": "",
      "left": 829.7960310435119,
      "top": 438.77235351656907,
      "width": 400,
      "height": 500,
      "scaleX": 0.7401665337559598,
      "scaleY": 0.6940333076064749,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7493635533101722661": {
      "type": "frame",
      "id": "7493635533101722661",
      "z": 1606,
      "textContent": "Frame 13",
      "left": 849.7960310435119,
      "top": 737.5432992672137,
      "width": 400,
      "height": 500,
      "scaleX": 0.6401665337559598,
      "scaleY": 0.05649141610518561,
      "fill": "transparent",
      "opacity": 0.05,
      "container": "7493635533102491110",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a4",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7493635533104228257": {
      "type": "frame",
      "id": "7493635533104228257",
      "z": 1616,
      "textContent": "Frame 21",
      "left": 849.7960310435119,
      "top": 737.5432992672137,
      "width": 400,
      "height": 500,
      "scaleX": 0.5848129620995713,
      "scaleY": 0.05649141610518561,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533101722661",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a5",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 1,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7493635533092638405": {
      "type": "shape",
      "id": "7493635533092638405",
      "z": 1626,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#4A388E\">Title</span></p>",
      "left": 930.0417390961047,
      "top": 743.6661532935101,
      "width": 41.062517627791394,
      "height": 29.86364918384829,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.53576841535674,
      "scaleY": 0.53576841535674,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.5,
      "textAlign": "left",
      "fontSize": 7.50075781499436,
      "angle": 0,
      "container": "7493635533104228257",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7493635533096299949": {
      "type": "wireframe",
      "id": "7493635533096299949",
      "z": 1636,
      "top": 737.5432992672137,
      "left": 849.7960310435119,
      "width": 52,
      "height": 52,
      "scaleX": 0.5431866933190925,
      "scaleY": 0.5431866933190925,
      "container": "7493635533104228257",
      "layoutPosition": "a0V",
      "wireframeName": "avatar",
      "fill": "#826AD8",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "user" }
      },
      "showBackground": true,
      "showOutline": true
    },
    "7493635533098978406": {
      "type": "shape",
      "id": "7493635533098978406",
      "z": 1646,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#4A388E\">Name</span></p>",
      "left": 879.0417390961047,
      "top": 739.6661532935101,
      "width": 61.96408106310109,
      "height": 29.742758910288526,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8069190915472872,
      "scaleY": 0.8069190915472872,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "left",
      "fontSize": 11.29686728166202,
      "angle": 0,
      "container": "7493635533104228257",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0l",
      "maskType": "none",
      "locked": false
    },
    "7493635533093675901": {
      "type": "shape",
      "id": "7493635533093675901",
      "z": 1676,
      "shapeName": "icon",
      "textContent": "",
      "left": 1083.7212158833404,
      "top": 742.7144072212633,
      "width": 100,
      "height": 88.88888888888889,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.20141428662555377,
      "scaleY": 0.20141428662555377,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#826AD8",
      "angle": 0,
      "container": "7493635533101722661",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a5",
      "maskType": "none",
      "iconName": "far/share-from-square",
      "locked": false,
      "reactions": {}
    },
    "7493635533096632447": {
      "type": "frame",
      "id": "7493635533096632447",
      "z": 1656,
      "textContent": "Frame 2",
      "left": 849.7960310435119,
      "top": 458.77235351656907,
      "width": 400,
      "height": 500,
      "scaleX": 0.6401665337559598,
      "scaleY": 0.3895418915012892,
      "fill": "#826AD8",
      "opacity": 0.05,
      "container": "7493635533102491110",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7493635533098569921": {
      "type": "shape",
      "id": "7493635533098569921",
      "z": 1666,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#4A388E\">Paragraph text</span></p>",
      "left": 849.7960310435119,
      "top": 673.5432992672137,
      "width": 107.27684264323969,
      "height": 29.317894883866742,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.500789881889256,
      "scaleY": 1.5007898818892562,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 21.011058346449584,
      "angle": 0,
      "container": "7493635533102491110",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a3",
      "wrapText": true,
      "maskType": "none",
      "locked": false
    }
  }
}
